import React, { Component, Fragment, FunctionComponent, useContext, useEffect, useState } from 'react';
import './Church-Investors-Fund.scss';


interface IProps {
  
}

const Help:FunctionComponent<IProps> = props => {
  
  


  return (
    <div className="church-investors">
        <h1>We're Here to Help</h1>
        <div className="scroll-wrapper">
          <div className="scroll-area">
            <p>Please contact our investments department at <a href="mailto:investments@ceif.org">investments@ceif.org</a> or call us at <a href="tel:1-800-543-2343">1-800-543-2343</a>, option 4.</p>
          </div>
        </div>
        
    </div>
  );
}

export default Help;